import React, { useState, useCallback, useEffect, useRef } from 'react'

// Deps
import { connect } from 'react-redux'
import throttle from 'lodash/throttle'
import CreditCards from 'creditcards'

// Functions
import getCardTypeImage from 'functions/get-card-type-image'

// Partials
import Btn from 'views/shared/partials/btn'
import Loader from 'views/shared/partials/loader'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Collapser from 'views/shared/partials/collapser'
import Image from 'views/shared/partials/image'
import Tabs from 'views/shared/partials/tabs'

// Utils
import { openModal } from 'utils/modals';

// Services
import orderServices from 'services/order'

// Data
import currencyTypes from 'data/currency-types'

const mapStateToProps = (state, ownProps) => {
	return {
		userData: state.user.data,
	};
};

const LoadBalanceModal = (props) => {
	const currencyType = props.currencyType;

	const formInstance = useRef();

	const [submitting, setSubmitting] = useState(false);
	const [displayMode, setDisplayMode] = useState('payment');
	const [cardMode, setCardMode] = useState('new');

	const [savedCardData, setSavedCardData] = useState(false);
	const [selectedCard, setSelectedCard] = useState(false);

	const [orderCurrency, setOrderCurrency] = useState(currencyTypes.find((type) => ( type.code === currencyType.currency_code)));
	const [orderTotal, setOrderTotal] = useState(parseInt(currencyType.credit) < 0 ? currencyType.credit.replace('-', '').replace('.', ',') : '');
	const [cardNumber, setCardNumber] = useState('');
	const [cardType, setCardType] = useState('');
	const [cardTypeImage, setCardTypeImage] = useState('');

	const cardTypeCheck = useCallback(throttle((cardVal) => {
		let type = CreditCards.card.type(cardVal.replace(/}D/g, ''), true);
		setCardType(type ? type : false);
		setCardTypeImage(getCardTypeImage(type ? type : false));
	}, 250, { leading: false }));

	const getSavedCards = (fetchedCards) => {
		const processCards = (cards) => {
			setSavedCardData(cards.map((card, nth) => {
				let type = CreditCards.card.type(card.card_bin_number, true);
				let priceTypeID = card.price_type_id ? card.price_type_id.toString() : false;

				return {
					...card,
					price_type_id: priceTypeID,
					currency: ((priceTypeID && priceTypeID !== '1') ? currencyTypes.find(type => type.value === priceTypeID).label : false),
					typeImage: getCardTypeImage(type ? type : false)
				}
			}));
		}

		if(fetchedCards) {
			processCards(fetchedCards);
		}
		else {
			setSavedCardData(null);
			
			orderServices.getCompanyCards().then((cards) => {
				processCards(cards);
			}).catch(() => {
				setCardMode('new');
			})
		}
	}

	const removeSavedCard = (e, card) => {
		e.preventDefault();

		openModal('confirm', {
			top: true,
			message: `${card.name} numaralı kartı kayıtlı kartlarınızdan kaldırmak istediğinize emin misiniz?`,
			onConfirm: () => {
				setSavedCardData(null);
				orderServices.removeCompanyCard(card.id).then((cards) => {
					getSavedCards(cards);
				}).catch(() => {
					getSavedCards();
				});
			},
		})
	}

	const changeCardAutoPayment = (e, card) => {
		e.preventDefault();

		// openModal('confirm', {
		// 	top: true,
		// 	message: `${card.name} numaralı kartı kayıtlı kartlarınızdan kaldırmak istediğinize emin misiniz?`,
		// 	onConfirm: () => {
		setSavedCardData(null);
		orderServices.setCardAutoPayment(card.id, card.auto_pay ? false : true).then((cards) => {
			getSavedCards(cards);
		}).catch(() => {
			getSavedCards();
		});
		// 	},
		// })
	}

	const submit = (formData) => {
		setSubmitting(true);

		let submitData = {
			...formData,
			create_or_update_order: 'create',

			callback_url: window.location.href.split('?')[0],
			account_id: props.userData.id,
		}

		if (cardMode === 'saved') {
			submitData = {
				...submitData,
				client_user_card_id: selectedCard,
			}
		}
		else {
			submitData = {
				...submitData,
				card_number: formData.card_number.replace(/ /g, ''),
				card_expires: formData.card_expires.replace(/\//g, ''),
			}

			if (formData.save_card) {
				// submitData.save_card_to_phone = cardSaveData.phone;
				// submitData.confirm_token = cardSaveData.token;
			}
		}

		orderServices.make3dBalancePayment(submitData).catch(() => {
			setSubmitting(false);
		});
	}

	useEffect(() => {
		// let newBin = cardNumber.replace(/ /g, '').substring(0, 6);
		cardTypeCheck(cardNumber);
	}, [cardNumber, cardTypeCheck])

	useEffect(() => {
		if(displayMode === 'payment') {
			if(cardMode === 'saved' && savedCardData === false) {
				getSavedCards();
			}
			else {
				setSelectedCard(false);
			}

			if(formInstance.current) {
				formInstance.current.setForceTouch(false);
			}
		}
		else {
			if(savedCardData === false) {
				getSavedCards();
			}
		}
	}, [cardMode, displayMode, savedCardData])

	useEffect(() => {
		if(selectedCard && orderCurrency && savedCardData) {
			let selectedCardInfo = savedCardData.find(card => card.id === selectedCard);

			if (selectedCardInfo.price_type_id && selectedCardInfo.price_type_id !== orderCurrency.id) {
				setSelectedCard(false);
				formInstance.current.setForceTouch(false);
			}
		}
	}, [orderCurrency, savedCardData, selectedCard]);

	useEffect(() => {
		let newCurrency = props.currencies.find((cur) => cur.currency_code === orderCurrency.code);
		if(newCurrency) {
			setOrderTotal(parseInt(newCurrency.credit) < 0 ? newCurrency.credit.replace('-', '').replace('.', ',') : '');
		}
	}, [orderCurrency, props.currencies])

	return (
		<div className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">Bakiye Yükle</h1>
				{props.closeBtn}
			</div>

			<Tabs
				onChange={(key) => {
					setDisplayMode(key);
				}}
				className="balance-tabs">
				<div
					index="payment"
					icon="payment"
					label="Tek Seferlik Yükleme">
					<InputForm
						ignoreEmpty
						onSubmit={submit}
						className="balance-payment"
						ref={formInstance}>
						<div className="modal-content">
							<div className="modal-group grid-container">
								<div className="row">
									<div className="col x6">
										<FormInput
											big
											disabled={submitting}
											type="number"
											label="Yükleme Tutarı"
											mask="number"
											value={orderTotal}
											onChange={setOrderTotal}
											validation={{
												required: "Yükleme tutarını girmelisiniz"
											}}
											decimals={2}
											name="price" />
									</div>
									<div className="col x4">
										<FormInput
											big
											disabled={submitting}
											type="select"
											z="5"
											defaultValue={currencyTypes[0]}
											label="Para Birimi"
											value={orderCurrency}
											onChange={(cur) => { setOrderCurrency(cur); }}
											options={currencyTypes}
											name="price_type_id" />
									</div>
								</div>
							</div>

							{cardMode === 'new' ?
								<Collapser
									className="modal-group dark cardinfo"
									title="Kart Bilgileri"
									open disableToggle>
									<div className="grid-container">
										<div className="row">
											<div className="col al-right">
												<Btn
													className="blue-bg"
													small low
													onClick={() => {setCardMode('saved')}}
													afterIcon="doublearrow-right">
													Kayıtlı Kartlar
												</Btn>
											</div>
										</div>
										<div className="row">
											<div className="col x7">
												<FormInput
													className="cardinfo-cardnumber"
													disabled={submitting}
													label="Kredi Kart No"
													name="card_number"
													mask="creditCard"
													validation={{
														required: 'Kartı numarasını girmelisiniz.',
														creditCard: 'Geçerli bir kart numarası girmelisiniz.',
													}}
													value={cardNumber}
													onChange={setCardNumber}
													innerContent={<div className="cardnumber-type">
														<Image
															bg contain
															className="type-image"
															src={cardTypeImage} />
													</div>}
													hideAsterisk
													type="text" />
											</div>
											<div className="col x3 m-x8">
												<FormInput
													disabled={submitting}
													label="Son K.T"
													name="card_expires"
													mask="expiry"
													validation={{
														required: 'S.K. girmelisiniz.',
														expiry: 'Geçerli bir S.K. girmelisiniz.',
													}}
													type="text" />
											</div>
											<div className="col x2 m-x4">
												<FormInput
													disabled={submitting}
													label="CVV"
													name="card_cvv"
													maxLength={4}
													mask="numeric"
													validation={{
														required: 'CVV girmelisiniz.',
														cvv: ['Geçerli bir CVV girmelisiniz.', cardType],
													}}
													type="text" />
											</div>
										</div>
										<div className="row">
											<div className="col x9">
												<FormInput
													disabled={submitting}
													label="Kartın Üzerindeki İsim"
													name="card_name"
													validation={{
														required: 'Kart üzerindeki ismi girmelisiniz.',
														fullName: 'Geçerli bir isim girmelisiniz.',
													}}
													type="text" />
											</div>
										</div>
										<div className="row">
											<div className="col">
												<FormInput
													disabled={submitting}
													type="checkbox"
													value="1"
													name="save_card"
													label={<React.Fragment>Hızlı ödeme için <strong>bu kartı kaydet</strong></React.Fragment>} />
											</div>
										</div>
									</div>
								</Collapser>
								:
								<Collapser
									className="modal-group dark"
									title="Kayıtlı Kartlarım"
									open disableToggle>
									<div className="grid-container">
										<div className="row">
											<div className="col al-right">
												<Btn
													className="blue-bg"
													small low
													onClick={() => {setCardMode('new')}}
													icon="card">
													Yeni Bir Kartla Öde
												</Btn>
											</div>
										</div>
										<div className="row">
											<div className="col loader-container low">
												<Loader
													dark
													loading={!savedCardData}
													message="Kayıtlı kartlarınız getiriliyor..." />
												{savedCardData &&
													<React.Fragment>
														{savedCardData && savedCardData.length > 0 ?
															<FormInput
																disabled={submitting}
																block
																className="cards-select"
																type="radio"
																value={selectedCard}
																onChange={setSelectedCard}
																name="client_user_card_id"
																validation={{
																	required: 'Bir kart seçmelisiniz.'
																}}
																options={savedCardData.map((card, nth) => ({
																	value: card.id,
																	disabled: ((card.price_type_id && card.price_type_id !== orderCurrency.value) || (!card.price_type_id && orderCurrency.value !== '1')),
																	labelClass: 'opts-card cardbar',
																	label: <React.Fragment>
																		<div className="cardbar-type">
																			<Image
																				bg contain
																				className="type-image"
																				src={card.typeImage} />
																		</div>
																		
																		<span className="cardbar-label">
																			{card.name}
																			{card.currency && <span className="label-currency">{card.currency}</span>}
																			{card.auto_pay && <span className="label-autopay"><i className="icon-check"></i> Otomatik Ödeme</span>}
																		</span>
																		<span className="cardbar-info">{card.card_bank_name}</span>
																		<div className="cardbar-controls">
																			<Btn
																				onClick={(e) => { removeSavedCard(e, card)}}
																				small low error outline
																				icon="trash">
																			</Btn>
																		</div>
																	</React.Fragment>,
																}))} />
															:
															<div className="alert center">
																<i className="alert-icon icon-alert-2"></i>
																<div className="alert-content">Hiç kayıtlı kartınız bulunmuyor.</div>
															</div>
														}
													</React.Fragment>
												}
											</div>
										</div>
									</div>
								</Collapser>
							}
						</div>

						<div className="modal-controls">
							<Btn
								nude
								disabled={submitting}
								onClick={props.close}>
								Vazgeç
							</Btn>
							<Btn
								loading={submitting}
								disabled={submitting}
								type="submit">
								Ödeme Yap
							</Btn>
						</div>
					</InputForm>
				</div>
				<div
					index="autopayment"
					icon="time"
					label="Otomatik Yükleme">
					<div className="modal-content balance-autopayment">
						<div className="wysiwyg">
							<p>Bakiyeniz her ayın son günü otomatik ödeme özelliğini aktive ettiğiniz kayıtlı kartlarınızdan tahsil edilir. Kayıtlı kartlarınızın otomatik ödeme özelliğini aşağıdaki listeden yönetebilirsiniz.</p>
							<p>Kayıtlı kart eklemek için o kartla en az bir kere bakiye yüklemeniz gerekmektedir.</p>
						</div>

						<div
							className="autopayment-cardlist">
							<div className="loader-container low">
								<Loader
									dark
									loading={!savedCardData}
									message="Kayıtlı kartlarınız getiriliyor..." />
								{savedCardData &&
									<React.Fragment>
										{savedCardData && savedCardData.length > 0 ?
											<div className="cardlist-list">
												{savedCardData.map((card, nth) => ((
													<div className="list-card cardbar" key={nth}>
														<div className="cardbar-type">
															<Image
																bg contain
																className="type-image"
																src={card.typeImage} />
														</div>

														<span className="cardbar-label">
															{card.name}
															{card.currency && <span className="label-currency">{card.currency}</span>}
															{card.auto_pay && <span className="label-autopay"><i className="icon-check"></i> Otomatik Ödeme</span>}
														</span>
														<span className="cardbar-info">{card.card_bank_name}</span>
														<div className="cardbar-controls">
															<Btn
																onClick={(e) => { changeCardAutoPayment(e, card) }}
																small low blue
																outline={card.auto_pay ? undefined : true}
																title={card.auto_pay ? 'Otomatik ödemeyi deaktive et' : 'Otomatik ödemeyi aktifleştir'}
																icon="time">
															</Btn>
															<Btn
																onClick={(e) => { removeSavedCard(e, card) }}
																small low error outline
																title="Kayıtlı kartı sil"
																icon="trash">
															</Btn>
														</div>
													</div>
												)))}
											</div>
											:
											<div className="alert center">
												<i className="alert-icon icon-alert-2"></i>
												<div className="alert-content">Hiç kayıtlı kartınız bulunmuyor.</div>
											</div>
										}
									</React.Fragment>
								}
							</div>
						</div>
					</div>
					<div className="modal-controls">
						<Btn
							disabled={submitting}
							onClick={props.close}>
							Tamam
						</Btn>
					</div>
				</div>
			</Tabs>
		</div>
	)
}

const ConnectedModal = connect(mapStateToProps)(LoadBalanceModal);

ConnectedModal.defaultProps = {
	className: '',
	containerClass: 'modal-load-balance mobile-full',
	name: 'load-balance',
	currencyType: false,
}

export default ConnectedModal